import React, { useState } from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts';
import { Segmented } from '@/components/admin/Segmented';
import { Panel, Big } from './parts';

const fmtDay = (d) => new Date(`${d}T00:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

export const VisitorsChart = ({ v }) => {
  const [metric, setMetric] = useState('visitors');
  const t = v.totals;
  return (
    <Panel title="Website visitors" testId="growth-visitors">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-5">
        <Big label="All visitors" value={t.all_visitors} testId="growth-all-visitors" />
        <Big label="Marketing page visitors" value={t.marketing.visitors} sub={`${t.marketing.views} page views`} tone="text-[#00247D]" testId="growth-marketing-visitors" />
        <Big label="League page visitors" value={t.league.visitors} sub={`${t.league.views} page views`} tone="text-[#CF142B]" testId="growth-league-visitors" />
        <div className="flex items-end sm:justify-end">
          <div className="w-full sm:w-[220px]">
            <Segmented value={metric} options={[['visitors', 'Visitors'], ['views', 'Page views']]} onChange={setMetric} testId="growth-chart-metric" />
          </div>
        </div>
      </div>
      <div className="h-[260px]" data-testid="growth-visitors-chart">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={v.daily} margin={{ top: 5, right: 8, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
            <XAxis dataKey="day" tickFormatter={fmtDay} tick={{ fontSize: 11, fill: '#64748b' }} minTickGap={24} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#64748b' }} />
            <Tooltip labelFormatter={fmtDay} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Area type="monotone" dataKey={`marketing_${metric}`} name="Marketing pages" stroke="#00247D" fill="#00247D" fillOpacity={0.15} strokeWidth={2} />
            <Area type="monotone" dataKey={`league_${metric}`} name="League pages" stroke="#CF142B" fill="#CF142B" fillOpacity={0.12} strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <p className="text-xs text-slate-400 mt-3">Counts visitors who aren't signed in. Marketing pages are the homepage, pricing, sport pages, blog and bracket library; league pages are shared schedules and leaderboards. Bots are left out.</p>
    </Panel>
  );
};
